module.exports = __webpack_public_path__ + "static/media/Sopadecarnes.3a6cbd98.jpg";